import React, { useEffect } from 'react';
import { Route as ReactRouteDom, type RouteProps, type RouteComponentProps } from 'react-router-dom';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

const WrappedRoute: React.FC<RouteComponentProps & Pick<RouteProps, 'component' | 'render' | 'children'> & { useTrailingSlash: boolean }> = (props) => {
    const { location, history, useTrailingSlash, component: Component, render, children } = props;
    const { pathname } = location;

    useEffect(() => {
        if (pathname === '/') {
            return;
        }

        if (useTrailingSlash && pathname.slice(-1) !== '/') {
            history.replace({
                ...location,
                pathname: `${pathname}/`
            });

            return;
        }

        if (!useTrailingSlash && pathname.slice(-1) === '/') {
            history.replace({
                ...location,
                pathname: pathname.slice(0, -1)
            });
        }
    }, [useTrailingSlash, pathname, location, history]);

    if (Component) {
        return <Component {...props} />;
    }

    if (render) {
        return (
            <>
                {render(props)}
            </>
        );
    }

    return (
        <>
            {children}
        </>
    );
};

export const Route: React.FC<RouteProps> = (props) => {
    const { children, component, render, ...routeProps } = props;
    const { useTrailingSlash } = useAppSelector(prop('seo'));

    return (
        <ReactRouteDom {...routeProps} render={(compProps: RouteComponentProps) => (
            <WrappedRoute {...{ ...compProps, useTrailingSlash, component, render }} >
                {children}
            </WrappedRoute>
        )} />
    );
};
